import React, { Component } from 'react';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import history from './history';
import Main from './containers/Main';
// import socketConnection from './utils/common/socketConnection';
import { resetErrorModal, setBranchPK } from './utils/common/actions';
// import { ReactComponent as ErrorIcon } from './static/assets/report-24px.svg';
import './App.css';
import { PREFIX_URL } from './constants';
import AuthGate from './components/AuthGate';
import { buildAuthLogoutUrl } from './authConfig';
import { clearStoredAuthSession, getStoredAuthToken, hydrateAuthSessionFromQueryString } from './utils/authSession';


class App extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.onIdle = this._onIdle.bind(this);
    this.state = {
      isAuthenticated: Boolean(getStoredAuthToken())
    };
  }

  componentDidMount() {
    // this.props.socketConnection();
    // this.props.setBranchPK(new URLSearchParams(history.location.search).get("branch_pk"))

    const queryString = window.location.search || '';
    const authReceived = hydrateAuthSessionFromQueryString(queryString);
    const logoutRequested = new URLSearchParams(queryString).get('logged_out') === '1';

    if (authReceived || logoutRequested) {
      if (logoutRequested) {
        clearStoredAuthSession();
      }

      const pathname = window.location.pathname || PREFIX_URL;
      const normalizedPathname = pathname === '/' || pathname === '/pmm' ? PREFIX_URL : pathname;
      history.replace(normalizedPathname);
      
      this.setState({ isAuthenticated: Boolean(getStoredAuthToken()) });
    }

    if (getStoredAuthToken() && (window.location.pathname === '/' || window.location.pathname === '/pmm')) {
      history.replace(PREFIX_URL);
    }
  }

  _onIdle(e) {
    const newPath = PREFIX_URL;
    if (history.location.pathname !== newPath) {
      history.push(newPath);
    }
  }

  handleLogout = () => {
    clearStoredAuthSession();
    window.location.href = buildAuthLogoutUrl(`${window.location.origin}${PREFIX_URL}`);
  };

  render() {
    const { isLoading, offlineMode } = this.props;
    const isAuthenticated = Boolean(getStoredAuthToken());

    return (
      <AuthGate
        isAuthenticated={isAuthenticated}
      >
        <div className="App h-100">
          <button
            type="button"
            className="app-logout-btn"
            onClick={this.handleLogout}
            aria-label="Sign out"
            title="Sign out"
          >
            Sign out
          </button>
          {offlineMode && (
            <div className="offline-banner">
              Offline mode — showing sample data (Node-RED endpoint unreachable)
            </div>
          )}
          {/*TODO fix error modal logic*/}
          {/*<div className={`error-modal ${error ? 'visible' : ''}`}>*/}
          {/*  <div className="error-icon-container">*/}
          {/*    <ErrorIcon className="error-icon" />*/}
          {/*  </div> */}
          {/*  {error} */}
          {/*  <div */}
          {/*      className="close-button" */}
          {/*      onClick={this.props.resetErrorModal}>*/}
          {/*    x*/}
          {/*  </div>*/}
          {/*</div>*/}

          <div className={`common-loader ${isLoading ? 'visible' : ''}`}>
            <div className="lds-dual-ring"></div>
          </div>
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onIdle={this.onIdle}
            debounce={250}
            timeout={1000 * 60 * 5}
          />
          <Main />
        </div>
      </AuthGate>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.common.isLoading,
    offlineMode: state.common.offlineMode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // socketConnection() {
    //   dispatch(socketConnection());
    // },
    resetErrorModal() {
      dispatch(resetErrorModal());
    },
    setBranchPK(branchPk) {
      dispatch(setBranchPK(branchPk));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
